import { useState, useEffect, useCallback, useMemo } from 'react';
import Modal, { PrimaryModal } from 'components/molecules/Modal';
import OrdersApi from 'libs/api/orders';
import {
  orderStatuses,
  OrderTypes,
  reservationStatuses,
} from 'common/constants/orders';
import RestaurantsApi from 'libs/api/restaurants';
import ReservationsApi from 'libs/api/reservations';
import moment from 'moment-timezone';
import {
  InputError,
  Divider as PrimaryDivider,
} from 'components/atoms/styleds';
import {
  OrderInfoRow,
  OrderInfoText,
  Divider,
  Button,
  StyledList,
  OrderSpecialDishes,
  StyledListItem,
  MessageDialogWrapper,
  MessagesBox,
  MessagesBoxItemTitle,
  MessagesBoxItem,
  MessagesBoxItemText,
  MessageInputWrapper,
  SecondBlock,
  WarningText,
  BonusText,
  BonusDontForgetText,
} from './styled';
import Textarea from 'components/atoms/Textarea';
import { useDynamicApi } from 'hooks/api/dynamic-api';
import MessageDialogApi from 'libs/api/message_dialog';
import MessagesApi from 'libs/api/messages';
import { fetchAllPagesFromListApi } from 'utils/pagination';
import UIHelper from 'services/UIHelper';
import { useUser } from 'redux/user/use-user';
import { capitalizeFirstLetter, getReservationViewInfo } from 'utils';
import Select from 'components/atoms/Select';
import TablesApi from 'libs/api/table';
import AdminOrdersApi from 'libs/api/adminOrders';
import { isMobile } from 'react-device-detect';
import { ReactComponent as PercentageIcon } from 'assets/images/percentage.svg';

const api = new OrdersApi();
const restaurantApi = new RestaurantsApi();

const Dishes = ({ dish }) => {
  const options = dish.options;
  return (
    <StyledListItem>
      <OrderInfoRow desktop_pb={0}>
        <OrderInfoText tAlign='left' title={false}>
          {dish.title || dish.title_it}
          {!!options?.length && (
            <OrderSpecialDishes>
              {options?.map((opt, index) => {
                return (
                  <span key={opt.id}>
                    {opt.option?.title || opt.option?.title_it} ({opt.count}){' '}
                    {opt.option.price}€{index !== options.length - 1 && ', '}
                  </span>
                );
              })}
            </OrderSpecialDishes>
          )}
        </OrderInfoText>
        <OrderInfoText as='div' style={{ display: 'flex' }} title={false}>
          <OrderInfoText pr={50} title={false} tAlign='right'>
            {dish.count}
          </OrderInfoText>
          <OrderInfoText pr={14} title={false} tAlign='right'>
            {dish.price_cents}
            {!!options?.length && (
              <OrderSpecialDishes>{dish.options_sum}</OrderSpecialDishes>
            )}
          </OrderInfoText>
        </OrderInfoText>
      </OrderInfoRow>
    </StyledListItem>
  );
};

const SpecialMenuDishes = ({ dish }) => {
  const manyDishesVariant = dish.typology === 'many_dishes';
  return (
    <StyledListItem>
      <OrderInfoRow desktop_pb={0}>
        <OrderInfoText tAlign='left' title={false}>
          {/*{manyDishesVariant ? dish.selected_dishes?.map(i => i.title) : dish.title}*/}
          {dish.title || dish.title_it}
          <OrderSpecialDishes>
            {manyDishesVariant ? (
              dish.selected_dishes?.map((i) => <p>-{i.title || i.title_it}</p>)
            ) : (
              <>
                {dish.special_menus_categories?.map((category) => {
                  return category.dishes_special_menus?.map((specialMenu) => {
                    return (
                      <p>
                        -
                        {specialMenu?.dish?.title ||
                          specialMenu?.dish?.title_it}
                      </p>
                    );
                  });
                })}
              </>
            )}
          </OrderSpecialDishes>
        </OrderInfoText>
        <OrderInfoText as='div' style={{ display: 'flex' }} title={false}>
          <OrderInfoText pr={50} title={false} tAlign='right'>
            {dish.count}
          </OrderInfoText>
          <OrderInfoText pr={14} title={false} tAlign='right'>
            {dish.price}
          </OrderInfoText>
        </OrderInfoText>
      </OrderInfoRow>
    </StyledListItem>
  );
};

const ListOfDishes = ({ dishes = [], Component }) => {
  const list = useMemo(() => {
    const sorted = {};
    dishes.forEach((i) => {
      sorted[i.queue] ? sorted[i.queue].push(i) : (sorted[i.queue] = [i]);
    });

    return sorted;
  }, [dishes]);

  return (
    <>
      {Object.keys(list).map((key) => {
        const items = list[key];
        return (
          <>
            <h2>Portata {key}</h2>
            {items.map((dish) => {
              return <Component key={dish.id} dish={dish} />;
            })}
          </>
        );
      })}
    </>
  );
};

const DeliveryOrder = ({
  order,
  errors,
  setShowMessageDialog,
  tableId,
  setTableId,
}) => {
  // const [tableId, setTableId] = useState(order.table_id);
  const [tables, setTables] = useState([]);
  const { api: tablesApi } = useDynamicApi(TablesApi);
  // TODO ask Boris, what the fuck is this
  const isExpired = moment(order.date_from).isBefore(new Date());

  const { api: orderApi } = useDynamicApi(AdminOrdersApi);

  useEffect(() => {
    (async () => {
      try {
        const tables = await fetchAllPagesFromListApi(tablesApi, {
          itemsKey: 'tables',
        });
        setTables(tables);
      } catch (e) {}
    })();
  }, [tablesApi]);

  const [phone, setPhone] = useState({
    value: '',
    inProcess: false,
    errors: null,
  });

  const onClickPhone = useCallback(
    async (e) => {
      try {
        setPhone((s) => ({
          ...s,
          inProcess: true,
        }));
        e.preventDefault();
        const {
          data: { virtual_phone },
        } = await api.getVirtualTel(order?.id);
        setPhone((s) => ({
          ...s,
          value: virtual_phone,
          inProcess: false,
        }));
        if (isMobile) {
          document.location.href = `tel:${virtual_phone}`;
        }
      } catch (e) {
        setPhone((s) => ({
          ...s,
          errors: e?.response?.data?.virtual_phone_service,
          inProcess: false,
        }));
      }
    },
    [order],
  );

  const renderErrors = () => {
    try {
      const err = [];
      if (errors) {
        Object.keys(errors).forEach((key) => {
          err.push(errors[key].join('/n'));
        });
      }

      return err.join('/n');
    } catch (e) {
      return null;
    }
  };

  const onChangeTable = useCallback(
    async (e) => {
      const {
        target: { value },
      } = e;
      try {
        await orderApi.put(order.id, {
          data: {
            table_id: value,
          },
        });
        // setTableId(value);
      } catch (e) {}
    },
    [order, orderApi],
  );
  console.log('order', order);

  const err = renderErrors();
  const phoneErrors = phone.errors;
  const time = moment(order.date_from).tz('Europe/Rome');

  const bonus =
    order?.reservation?.admin_bonus_value || order.admin_bonus_value;
  return (
    <div style={{ position: 'relative' }}>
      {order?.order_type === 'on_table' ? (
        <>
          <OrderInfoRow>
            <OrderInfoText title={true}>Giorno</OrderInfoText>
            <OrderInfoText title={false}>
              {capitalizeFirstLetter(time.format('dddd DD MMMM'))}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Servizio</OrderInfoText>
            <OrderInfoText title={false}>
              {/*TODO need api*/}
              {order?.service?.title}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>N° coperti</OrderInfoText>
            <OrderInfoText
              style={{ textTransform: 'capitalize' }}
              title={false}
            >
              {order.count || order?.visitor_count} persone
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Arrivo previsto</OrderInfoText>
            <OrderInfoText
              style={{ textTransform: 'capitalize' }}
              title={false}
            >
              {time.format('HH:mm')}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Nome cliente</OrderInfoText>
            <OrderInfoText title={false}>
              {order?.name} {order.surname}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Cellulare</OrderInfoText>
            <OrderInfoText title={false}>{order?.phone}</OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>email</OrderInfoText>
            <OrderInfoText title={false}>{order?.email}</OrderInfoText>
            <Divider />
          </OrderInfoRow>
        </>
      ) : (
        <>
          <OrderInfoRow>
            <OrderInfoText title={true}>Nome cliente</OrderInfoText>
            <OrderInfoText title={false}>
              {order?.name} {order.surname}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Indirizzo</OrderInfoText>
            <OrderInfoText title={false}>
              {order?.city && `${order?.city}, `} {order?.street}{' '}
              {order?.building && `, ${order?.building}`}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Data e ora</OrderInfoText>
            <OrderInfoText
              style={{ textTransform: 'capitalize' }}
              title={false}
            >
              {moment(order?.delivery_date)
                .tz('Europe/Rome')
                .format('DD MMMM HH:mm')}
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Tipo di ordine</OrderInfoText>
            <OrderInfoText
              style={{ textTransform: 'capitalize' }}
              title={false}
            >
              {order?.order_type?.split('_')?.join(' ')}
            </OrderInfoText>
            <Divider />
          </OrderInfoRow>
        </>
      )}
      <OrderInfoRow desktop_pt={20}>
        <OrderInfoText title={true}>Riepilogo ordine</OrderInfoText>
        <OrderInfoText title={false}>{order?.some}</OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Piatti/Prodotti</OrderInfoText>
        <OrderInfoText as='div' style={{ display: 'flex' }} title={true}>
          <OrderInfoText title={true} tAlign='right'>
            Quantità
          </OrderInfoText>
          <OrderInfoText title={true} tAlign='right'>
            Prezzo €
          </OrderInfoText>
        </OrderInfoText>
        <Divider />
      </OrderInfoRow>
      <OrderInfoRow as='div' style={{ display: 'block', paddingBottom: 0 }}>
        {/*TODO need change and improve*/}
        <StyledList
          className='ristora-scroll'
          style={{ paddingLeft: 16, marginTop: 10 }}
          pb={10}
        >
          <ListOfDishes dishes={order?.dishes} Component={Dishes} />
          <ListOfDishes
            dishes={order?.special_menus}
            Component={SpecialMenuDishes}
          />
          {/*{order?.dishes?.map((dish, index) => (*/}
          {/*  <Dishes key={`${dish.id}_${index}`} dish={dish} />*/}
          {/*))}*/}
          {/*{order?.special_menus?.map((dish, index) => {*/}
          {/*  return <SpecialMenuDishes key={dish.id} dish={dish} />;*/}
          {/*})}*/}
        </StyledList>
        <Divider />
      </OrderInfoRow>
      <OrderInfoRow desktop_pt={10} desktop_pb={10}>
        <OrderInfoText title={true}>Costo della consegna:</OrderInfoText>
        <OrderInfoText title={false}>
          {`${order?.delivery_cost}`} €
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow desktop_pt={0} desktop_pb={0}>
        <OrderInfoText title={true}>Totale in €</OrderInfoText>
        <OrderInfoText
          title={false}
          as='div'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <span>{order?.total_price_with_delivery} € </span>
          <BonusText as='div'>
            {order.discount_amount && (
              <span>- {order.discount_amount} € sconto</span>
            )}
          </BonusText>
          <BonusText as='div' color='#ff483b'>
            <span>
              {order?.payment?.amount
                ? 'L’ordine e’ stato pagato online'
                : 'Da pagare in cassa'}
            </span>
          </BonusText>
        </OrderInfoText>
      </OrderInfoRow>
      {/*{order?.discount && (*/}
      {/*  <OrderInfoRow>*/}
      {/*    <OrderInfoText title={true} />*/}
      {/*    <OrderInfoText*/}
      {/*      title={false}*/}
      {/*      as='div'*/}
      {/*      // style={{ display: 'flex', alignItems: 'center' }}*/}
      {/*    >*/}
      {/*      <span />*/}
      {/*      <BonusText as='span'>*/}
      {/*        <span>*/}
      {/*      - {order.discount[order.discount.bonus_type]}{' '}*/}
      {/*          {order.discount.bonus_type === 'percent_off' ? '%' : '€'} sconto*/}
      {/*/!*    </span>*!/*/}
      {/*      </BonusText>*/}
      {/*    </OrderInfoText>*/}
      {/*  </OrderInfoRow>*/}
      {/*)}*/}
      <OrderInfoRow desktop_pt={0} desktop_pb={10}>
        <OrderInfoText title={true}>Importo pagato online</OrderInfoText>
        <OrderInfoText title={false}>
          <span>{order?.payment?.amount} € </span>
        </OrderInfoText>
        <Divider />
      </OrderInfoRow>
      {bonus && (
        <OrderInfoRow>
          <BonusDontForgetText>
            Ricordati di fare lo sconto di {bonus} € quando il cliente
            effettuerà il pagamento.
          </BonusDontForgetText>
          <Divider />
        </OrderInfoRow>
      )}
      {order.order_type === 'on_table' && (
        <>
          <OrderInfoRow desktop_pt={20} desktop_pb={10}>
            <OrderInfoText title={true}>
              Assegna un tavolo alla prenotazione
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow desktop_pt={0} desktop_pb={20}>
            <OrderInfoText title={false}>
              Assegna un tavolo tenendo conto dei dettagli indicati nella
              prenotazione.
            </OrderInfoText>
          </OrderInfoRow>
          <Select
            standardWidth={true}
            label='Assegna tavolo'
            onChange={(e) => {
              const {
                target: { value },
              } = e;
              setTableId(value);
            }}
            selectedKey={tableId}
            items={tables}
          />
          <OrderInfoRow desktop_pt={0} desktop_pb={0}>
            <Divider />
          </OrderInfoRow>
        </>
      )}
      {/* <OrderInfoRow desktop_pt={10}>
        <OrderInfoText title={true}>
          Hai bisogno di contattare il cliente?
        </OrderInfoText>
      </OrderInfoRow> */}
      {/* <OrderInfoRow>
        <OrderInfoText title={false}>
          Se hai bisogno di ricevere maggiori informazioni dal cliente o
          desideri aggiornarlo riguardo la sua prenotazione, puoi chiamare
          oppure scrivere un messaggio.
        </OrderInfoText>
      </OrderInfoRow> */}
      <OrderInfoRow desktop_pb={20}>
        {/* {!isExpired && isMobile && (
          <Button
            disabled={phone.inProcess}
            mr={10}
            as='a'
            onClick={onClickPhone}
            href={`tel:${phone.value}`}
          >
            Chiama
            {phoneErrors && <InputError>{phoneErrors?.join('\n')}</InputError>}
          </Button>
        )} */}
        {/* <Button onClick={setShowMessageDialog}>Scrivi</Button> */}
        {/*<Divider />*/}
      </OrderInfoRow>
      <div>
        <WarningText title={true} style={{ fontSize: 14 }}>
          ATTENZIONE!! Se non farai alcuna scelta, l'ordine sarà validato
          automaticamente dopo 10 minuti dall'invio del primo sms. In caso tu
          non possa accettare, clicca “Rifiuta”
        </WarningText>
      </div>
      <OrderInfoRow>
        {err && (
          <InputError style={{ fontSize: 16, position: 'relative' }}>
            {err}
          </InputError>
        )}
      </OrderInfoRow>
    </div>
  );
};

const ReservationOrder = ({ order = {}, errors, setShowMessageDialog }) => {
  const [phone, setPhone] = useState({
    value: order.phone,
    inProcess: false,
    errors: null,
  });

  const isExpired = moment(order.delivery_date).isBefore(new Date());

  const { api: reservationApi } = useDynamicApi(ReservationsApi);

  const phoneErrors = phone.errors;

  const onClickPhone = useCallback(
    async (e) => {
      try {
        setPhone((s) => ({
          ...s,
          inProcess: true,
        }));
        e.preventDefault();
        const {
          data: { virtual_phone },
        } = await reservationApi.get(`${order.id}/virtual_phone`);
        setPhone((s) => ({
          ...s,
          value: virtual_phone,
          inProcess: false,
        }));
        if (isMobile) {
          document.location.href = `tel:${virtual_phone}`;
        }
      } catch (e) {
        setPhone((s) => ({
          ...s,
          errors: e?.response?.data?.virtual_phone_service,
          inProcess: false,
        }));
      }
    },
    [order, reservationApi],
  );
  const time = moment(order.date_from).tz('Europe/Rome');
  const renderErrors = () => {
    try {
      const err = [];
      if (errors) {
        Object.keys(errors).forEach((key) => {
          err.push(errors[key].join('/n'));
        });
      }

      return err.join('/n');
    } catch (e) {
      return null;
    }
  };

  const err = renderErrors();

  useEffect(() => {
    (async () => {
      try {
        // const {
        //   data: { virtual_phone },
        // } = await api.getVirtualTel(order?.id);
        // setPhone(virtual_phone);
      } catch (e) {}
    })();
  }, [order]);

  const { order: relationOrder } = order;
  const statusInfo = getReservationViewInfo(order);

  const hasOrder = !!relationOrder;

  console.log('relationOrder', relationOrder, order);
  const orderDiscount =
    !!relationOrder?.discount ||
    (relationOrder?.discount_amount &&
      relationOrder?.discount_amount !== '0,00');
  const adminBonusValue = order?.admin_bonus_value;

  return (
    <div style={{ position: 'relative' }}>
      <OrderInfoRow>
        <OrderInfoText title={true}>Giorno</OrderInfoText>
        <OrderInfoText title={false}>
          {capitalizeFirstLetter(time.format('dddd DD MMMM'))}
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Servizio</OrderInfoText>
        <OrderInfoText title={false}>
          {/*TODO need api*/}
          {order?.service?.title}
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>N° coperti</OrderInfoText>
        <OrderInfoText style={{ textTransform: 'capitalize' }} title={false}>
          {order.count || order.visitor_count} persone
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Arrivo previsto</OrderInfoText>
        <OrderInfoText style={{ textTransform: 'capitalize' }} title={false}>
          {time.format('HH:mm')}
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Nome cliente</OrderInfoText>
        <OrderInfoText title={false}>
          {order?.name} {order.surname}
        </OrderInfoText>
      </OrderInfoRow>
      {/* <OrderInfoRow>
        <OrderInfoText title={true}>Sala</OrderInfoText>
        <OrderInfoText title={false}>
          {order?.services_room?.room?.title}
        </OrderInfoText>
      </OrderInfoRow> */}
      <OrderInfoRow>
        <OrderInfoText title={true}>Cellulare</OrderInfoText>
        <OrderInfoText title={false}>{order?.phone}</OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Note</OrderInfoText>
        <OrderInfoText title={false}>
          {order?.notes === null || order?.notes === undefined || order?.notes === ''
            ? '-'
            : order?.notes}
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        <OrderInfoText title={true}>Stato</OrderInfoText>
        <OrderInfoText
          title={false}
          style={{
            color: statusInfo.color,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: 10,
              backgroundColor: statusInfo.color,
              display: 'inline-block',
            }}
          />
          {statusInfo.statusText}
        </OrderInfoText>
      </OrderInfoRow>
      <OrderInfoRow>
        {/* <OrderInfoText title={true}>email</OrderInfoText>
        <OrderInfoText title={false}>{order?.email}</OrderInfoText> */}
        <Divider />
      </OrderInfoRow>
      {hasOrder && (
        <>
          <OrderInfoRow desktop_pt={20} desktop_pb={10}>
            <OrderInfoText title={true}>Riepilogo ordine</OrderInfoText>
            <OrderInfoText title={false}>{order?.some}</OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow>
            <OrderInfoText title={true}>Piatti/Prodotti</OrderInfoText>
            <OrderInfoText as='div' style={{ display: 'flex' }} title={true}>
              <OrderInfoText title={true} tAlign='right'>
                Quantità
              </OrderInfoText>
              <OrderInfoText title={true} tAlign='right'>
                Prezzo €
              </OrderInfoText>
            </OrderInfoText>
            <Divider />
          </OrderInfoRow>
          <OrderInfoRow as='div' style={{ display: 'block', paddingBottom: 0 }}>
            <StyledList
              className='ristora-scroll'
              style={{ paddingLeft: 16, marginTop: 10 }}
              pb={10}
            >
              <ListOfDishes dishes={relationOrder?.dishes} Component={Dishes} />
              <ListOfDishes
                dishes={relationOrder?.special_menus}
                Component={SpecialMenuDishes}
              />
              {/*{relationOrder?.dishes?.map((dish) => {*/}
              {/*  return <Dishes key={dish.id} dish={dish} />;*/}
              {/*  // const options = dish.options;*/}
              {/*  // return (*/}
              {/*  //   <StyledListItem key={dish.id}>*/}
              {/*  //     <OrderInfoRow desktop_pb={0}>*/}
              {/*  //       <OrderInfoText tAlign='left' title={false}>*/}
              {/*  //         {dish.title || dish.title_it}*/}
              {/*  //         {!!options?.length && (*/}
              {/*  //           <OrderSpecialDishes>*/}
              {/*  //             {options?.map((opt, index) => {*/}
              {/*  //               return (*/}
              {/*  //                 <span key={opt.id}>*/}
              {/*  //                   {opt.option?.title || opt.option?.title_it} (*/}
              {/*  //                   {opt.count}) {opt.option.price}€*/}
              {/*  //                   {index !== options.length - 1 && ', '}*/}
              {/*  //                 </span>*/}
              {/*  //               );*/}
              {/*  //             })}*/}
              {/*  //           </OrderSpecialDishes>*/}
              {/*  //         )}*/}
              {/*  //       </OrderInfoText>*/}
              {/*  //       <OrderInfoText*/}
              {/*  //         as='div'*/}
              {/*  //         style={{ display: 'flex' }}*/}
              {/*  //         title={false}*/}
              {/*  //       >*/}
              {/*  //         <OrderInfoText pr={50} title={false} tAlign='right'>*/}
              {/*  //           {dish.count}*/}
              {/*  //         </OrderInfoText>*/}
              {/*  //         <OrderInfoText pr={14} title={false} tAlign='right'>*/}
              {/*  //           {dish.price_cents}*/}
              {/*  //           {!!options?.length && (*/}
              {/*  //             <OrderSpecialDishes>*/}
              {/*  //               {dish.options_sum}*/}
              {/*  //             </OrderSpecialDishes>*/}
              {/*  //           )}*/}
              {/*  //         </OrderInfoText>*/}
              {/*  //       </OrderInfoText>*/}
              {/*  //     </OrderInfoRow>*/}
              {/*  //   </StyledListItem>*/}
              {/*  // );*/}
              {/*})}*/}
              {/*{relationOrder?.special_menus?.map((dish) => {*/}
              {/*  return <SpecialMenuDishes key={dish.id} dish={dish} />;*/}
              {/*  // const manyDishesVariant = dish.typology === 'many_dishes';*/}
              {/*  // return (*/}
              {/*  //   <StyledListItem key={dish.id}>*/}
              {/*  //     <OrderInfoRow desktop_pb={0}>*/}
              {/*  //       <OrderInfoText tAlign='left' title={false}>*/}
              {/*  //         /!*{manyDishesVariant ? dish.selected_dishes?.map(i => i.title) : dish.title}*!/*/}
              {/*  //         {dish.title || dish.title_it}*/}
              {/*  //         <OrderSpecialDishes>*/}
              {/*  //           {manyDishesVariant ? (*/}
              {/*  //             dish.selected_dishes?.map((i) => <p>-{i.title}</p>)*/}
              {/*  //           ) : (*/}
              {/*  //             <>*/}
              {/*  //               {dish.special_menus_categories?.map(*/}
              {/*  //                 (category) => {*/}
              {/*  //                   return category.dishes_special_menus?.map(*/}
              {/*  //                     (specialMenu) => {*/}
              {/*  //                       return (*/}
              {/*  //                         <p>*/}
              {/*  //                           -*/}
              {/*  //                           {specialMenu?.dish?.title ||*/}
              {/*  //                             specialMenu?.dish?.title_it}*/}
              {/*  //                         </p>*/}
              {/*  //                       );*/}
              {/*  //                     },*/}
              {/*  //                   );*/}
              {/*  //                 },*/}
              {/*  //               )}*/}
              {/*  //             </>*/}
              {/*  //           )}*/}
              {/*  //         </OrderSpecialDishes>*/}
              {/*  //       </OrderInfoText>*/}
              {/*  //       <OrderInfoText*/}
              {/*  //         as='div'*/}
              {/*  //         style={{ display: 'flex' }}*/}
              {/*  //         title={false}*/}
              {/*  //       >*/}
              {/*  //         <OrderInfoText pr={50} title={false} tAlign='right'>*/}
              {/*  //           {dish.count}*/}
              {/*  //         </OrderInfoText>*/}
              {/*  //         <OrderInfoText pr={14} title={false} tAlign='right'>*/}
              {/*  //           {dish.price}*/}
              {/*  //         </OrderInfoText>*/}
              {/*  //       </OrderInfoText>*/}
              {/*  //     </OrderInfoRow>*/}
              {/*  //   </StyledListItem>*/}
              {/*  // );*/}
              {/*})}*/}
            </StyledList>
            <Divider />
          </OrderInfoRow>
          <OrderInfoRow desktop_pt={14} desktop_pb={14}>
            <OrderInfoText title={true}>Totale in €</OrderInfoText>
            <OrderInfoText
              title={false}
              as='div'
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {/*{relationOrder?.total_price} €*/}
              <span>{relationOrder?.total_price_with_delivery} €</span>
              <BonusText as='div'>
                {relationOrder.discount_amount && (
                  <span>- {relationOrder.discount_amount} € sconto</span>
                )}
              </BonusText>
              <BonusText as='div' color='#ff483b'>
                <span>
                  {relationOrder?.payment?.amount
                    ? 'L’ordine e’ stato pagato online'
                    : 'Da pagare in cassa'}
                </span>
              </BonusText>
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow desktop_pt={0} desktop_pb={10}>
            {/*<OrderInfoText title={true}>Totale riscosso</OrderInfoText>*/}
            <OrderInfoText title={true}>Importo pagato online</OrderInfoText>
            <OrderInfoText title={false}>
              <span>{relationOrder?.payment?.amount} € </span>
            </OrderInfoText>
            <Divider />
          </OrderInfoRow>
        </>
      )}
      {orderDiscount && (
        <>
          <OrderInfoRow desktop_pt={10} desktop_pb={0}>
            <OrderInfoText title={true} style={{ color: '#ff483b' }}>
              Sconto costo di prenotazione
            </OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow desktop_pt={0}>
            <BonusDontForgetText as='p' color='#ff483b'>
              Ricordati di stornare {orderDiscount} € quando il cliente
              effettuerà il pagamento per il costo di prenotazione anticipato.
            </BonusDontForgetText>
            <Divider />
          </OrderInfoRow>
        </>
      )}
      {adminBonusValue && (
        <>
          <OrderInfoRow desktop_pt={10} desktop_pb={0}>
            <OrderInfoText title={true}>Sconto dal salvadanaio</OrderInfoText>
          </OrderInfoRow>
          <OrderInfoRow desktop_pt={0}>
            <BonusDontForgetText as='p' color='#FF7828'>
              Ricordati di stornare {adminBonusValue} € quando il cliente
              effettuerà il pagamento per il costo di prenotazione anticipato.
            </BonusDontForgetText>
            <Divider />
          </OrderInfoRow>
        </>
      )}
      {/* <OrderInfoRow desktop_pt={10}>
        <OrderInfoText title={true}>
          Hai bisogno di contattare il cliente?
        </OrderInfoText>
      </OrderInfoRow> */}
      {/* <OrderInfoRow>
        <OrderInfoText title={false}>
          Se hai bisogno di ricevere maggiori informazioni dal cliente o
          desideri aggiornarlo riguardo la sua prenotazione, puoi chiamare
          oppure scrivere un messaggio.
        </OrderInfoText>
      </OrderInfoRow> */}
      <OrderInfoRow desktop_pb={20}>
        {/* {!isExpired && isMobile && (
          <Button
            disabled={phone.inProcess}
            onClick={onClickPhone}
            mr={10}
            as='a'
            href={`tel:${phone.value}`}
          >
            Chiama
            {phoneErrors && <InputError>{phoneErrors?.join('\n')}</InputError>}
          </Button>
        )} */}
        {/* <Button onClick={setShowMessageDialog}>Scrivi</Button> */}
        {/*<Divider />*/}
      </OrderInfoRow>
      <OrderInfoRow>
        {err && (
          <InputError style={{ fontSize: 16, position: 'relative' }}>
            {err}
          </InputError>
        )}
      </OrderInfoRow>
      <div>
        <WarningText title={true} style={{ fontSize: 14 }}>
          ATTENZIONE!! Se non farai alcuna scelta, la prenotazione sarà validata
          automaticamente dopo 10 minuti dall'invio del primo sms. In caso tu
          non possa accettare, clicca “Rifiuta”.
        </WarningText>
      </div>
    </div>
  );
};

const getDisabledStatuses = (order, isReservation) => {
  let disabledAction;
  let disableCancelAction;
  if (!isReservation) {
    disabledAction =
      order.status === orderStatuses.rejected ||
      order.status === orderStatuses.completed ||
      order.status === orderStatuses.preparing;
    disableCancelAction =
      order.status === orderStatuses.rejected ||
      order.status === orderStatuses.completed;
  } else {
    disabledAction =
      order.status === reservationStatuses.confirmed ||
      order.status === reservationStatuses.declined ||
      order.status === reservationStatuses.visited ||
      order.status === reservationStatuses.notVisited ||
      order.status === reservationStatuses.canceled;
    disableCancelAction =
      order.status === reservationStatuses.declined ||
      order.status === reservationStatuses.confirmed ||
      order.status === reservationStatuses.visited ||
      order.status === reservationStatuses.canceled;
  }

  return {
    disabledAction,
    disableCancelAction,
  };
};

const getModalParams = (showMessageDialog, showMessageTextArea) => {
  let cancelText = 'Rifiuta';
  let actionText = 'Conferma';

  if (showMessageDialog) {
    cancelText = 'Torna ai dettagli dell’ordine';
    actionText = 'Scrivi un nuovo messaggio';
    if (showMessageTextArea) {
      actionText = 'Invia';
      cancelText = 'Annulla';
    }
  }

  return {
    cancelText,
    actionText,
  };
};

export const MessagesContent = ({
  messages = [],
  showInput,
  message,
  onChange,
}) => {
  const hasData = messages.length > 0;
  return (
    <MessageDialogWrapper>
      {hasData && (
        <MessagesBox showInput={showInput} className='ristora-scroll'>
          {messages.map((i, index) => {
            return (
              <MessagesBoxItem fromMe={i.message_type === 'inbox'} key={index}>
                <MessagesBoxItemTitle>
                  {i.message_type === 'outbox' ? 'Tu' : 'Cliente'}
                </MessagesBoxItemTitle>
                <MessagesBoxItemText>{i.message}</MessagesBoxItemText>
              </MessagesBoxItem>
            );
          })}
        </MessagesBox>
      )}
      {showInput && (
        <SecondBlock>
          {hasData && (
            <PrimaryDivider mb={10} mobileMb={10} mt={10} desktopMt={10} />
          )}
          <MessageInputWrapper>
            <Textarea
              wrapperStyle={{ flex: 1, marginBottom: 0 }}
              style={{ height: '100%' }}
              label='Nuovo messaggio'
              placeholder='Scrivi qui il tuo messaggio'
              onChange={onChange}
              name='message'
              value={message}
            />
          </MessageInputWrapper>
        </SecondBlock>
      )}
    </MessageDialogWrapper>
  );
};

const OrderModal = ({
  order,
  onSubmit,
  onClose,
  onClickCancel,
  onComplete,
  inProcess,
  setSelectedOrder,
  isReservation = false,
  currentRestaurant,
  errors,
  afterChange,
}) => {
  const [tableId, setTableId] = useState(order.table_id);
  const { userData } = useUser();
  const { api: dialogApi } = useDynamicApi(MessageDialogApi);
  const { api: messageApi } = useDynamicApi(MessagesApi);
  const [createInProcess, setCreateInProcess] = useState(false);
  const [waitingForRequest, setWaitingForRequest] = useState(false);

  useEffect(() => {
    if (order) {
      setTableId(order.table_id);
    }
  }, [order]);

  const [message, setMessage] = useState('');
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [showMessageTextArea, setShowMessageTextArea] = useState(false);
  const { disabledAction, disableCancelAction } = getDisabledStatuses(
    order,
    isReservation,
  );
  const hideCancelButton =
    !showMessageDialog &&
    isReservation &&
    (order.status === reservationStatuses.confirmed ||
      order.status === reservationStatuses.declined);
  const [messagesList, setMessagesList] = useState([]);
  // TODO need get this cred from order data
  const hasMessages = !!order.message_dialog_id;
  const { cancelText, actionText } = getModalParams(
    showMessageDialog,
    showMessageTextArea,
  );

  const onChange = useCallback((e) => {
    const {
      target: { value },
    } = e;
    setMessage(value);
  }, []);

  const fetchMessages = useCallback(async () => {
    try {
      const { data } = await messageApi.list({
        params: {
          message_dialog_id: order.message_dialog_id || null,
        },
      });
      setMessagesList(data.messages);
      setWaitingForRequest(false);
    } catch (e) {}
  }, [messageApi, order]);

  const onClickShowMessages = useCallback(async () => {
    if (!hasMessages) {
      setShowMessageDialog(true);
      setShowMessageTextArea(true);
    } else {
      try {
        await fetchMessages();
        setShowMessageDialog(true);
        setShowMessageTextArea(false);
      } catch (e) {}
    }
  }, [hasMessages, fetchMessages]);

  useEffect(() => {
    if (waitingForRequest && hasMessages) {
      fetchMessages();
    }
  }, [hasMessages, waitingForRequest, fetchMessages]);

  const onSubmitMessage = useCallback(async () => {
    setCreateInProcess(true);
    try {
      await messageApi.create({
        data: {
          author_id: userData.id,
          message_dialog_id: order.message_dialog_id || null,
          message,
          message_type: 'outbox',
          date_send: new Date(),
          targetable_type: !isReservation ? 'Order' : 'Reservation',
          targetable_id: order.id,
        },
      });
      if (afterChange) {
        afterChange();
      }
      if (!hasMessages) {
        setWaitingForRequest(true);
      } else {
        fetchMessages();
      }
      setMessage('');
      UIHelper.showSuccessMessage();
    } catch (e) {
    } finally {
      setCreateInProcess(false);
    }
  }, [
    order,
    dialogApi,
    messageApi,
    message,
    currentRestaurant,
    hasMessages,
    userData,
    fetchMessages,
    afterChange,
    isReservation,
  ]);

  // const hideFooter = order?.order_type === 'on_table';
  const hideFooter = false;

  return (
    <PrimaryModal
      hideFooter={hideFooter}
      onSubmit={() => {
        if (showMessageDialog && !showMessageTextArea) {
          setShowMessageTextArea(true);
        }
        if (showMessageDialog && showMessageTextArea) {
          onSubmitMessage();
        }
        if (!showMessageDialog) {
          if (order.order_type === OrderTypes.on_table) {
            // setSelectedOrder && setSelectedOrder(null);
            onComplete();
            return;
          }
          //TODO ARTYOM
          if (tableId) {
            onSubmit({ table_id: tableId });
          } else {
            onSubmit();
          }
        }
      }}
      onClose={onClose}
      onCancel={() => {
        if (showMessageDialog && !showMessageTextArea) {
          setShowMessageDialog(false);
          setMessage('');
        }
        if (showMessageDialog && showMessageTextArea) {
          if (!hasMessages) {
            setShowMessageDialog(false);
          }
          setShowMessageTextArea(false);
          setMessage('');
        }
        if (!showMessageDialog) {
          if (order.order_type === OrderTypes.on_table) {
            setSelectedOrder && setSelectedOrder(null);
            return;
          }
          onClickCancel();
        }
      }}
      open={true}
      cancelButtonColor={order.order_type === OrderTypes.on_table && 'primary'}
      actionButtonText={
        // order.order_type === OrderTypes.on_table ? 'Evadi' : actionText
        actionText
      }
      cancelButtonText={
        hideCancelButton
          ? null
          : // order.order_type === OrderTypes.on_table ? 'Stampa Ordine' : cancelText
            cancelText
      }
      variant='config'
      desktopW={740}
      desktopMinH={isReservation ? '50vh' : '50vh'}
      desktopMaxH={'60vh'}
      buttonColor='action'
      title={
        showMessageDialog
          ? 'Conversazione'
          : isReservation
          ? 'Dettagli prenotazione tavolo'
          : 'Dettagli ordine'
      }
      showDivider={true}
      inProcess={createInProcess || inProcess}
      primaryHeader={true}
      disabled={
        order.order_type === OrderTypes.on_table
          ? false
          : !showMessageDialog && disabledAction
      }
      showFooterDivider={true}
      disabledCancel={!showMessageDialog && disableCancelAction}
      body={
        <>
          {showMessageDialog ? (
            <MessagesContent
              onChange={onChange}
              messages={messagesList}
              message={message}
              showInput={showMessageTextArea}
            />
          ) : (
            <>
              {isReservation ? (
                <ReservationOrder
                  setShowMessageDialog={onClickShowMessages}
                  order={order}
                  errors={errors}
                />
              ) : (
                <DeliveryOrder
                  setTableId={setTableId}
                  tableId={tableId}
                  errors={errors}
                  currentRestaurant={currentRestaurant}
                  order={order}
                  setShowMessageDialog={onClickShowMessages}
                />
              )}
            </>
          )}
        </>
      }
    />
  );
};

export default OrderModal;
